@if (tpCapacity$ | async; as tpCapacity) {
  <button
    #origin="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="tp-capacity-btn"
    type="button"
    [class.full]="tpCapacity.isTotalFull"
    (click)="toggle()"
  >
    <i [nimbusIcon]="ICONS.TASK"></i>
  </button>

  <ng-template
    cdkConnectedOverlay
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOpen]="isOpen$ | async"
    (backdropClick)="close()"
  >
    <div class="tp-capacity-popup">
      <div class="capacity-row">
        <span class="total-label">{{ TranslationKeys.AdminUserTaskParallelizationTotalCapacity | translate }}:</span>
        <span class="total-value" [class.limit-reached]="tpCapacity.isTotalFull"
          >{{ tpCapacity.total.current }}/{{ tpCapacity.total.limit }}</span
        >
      </div>
      <div class="modality-rows">
        @for (modality of tpCapacity.modalities; track modality.type) {
          <div class="capacity-row">
            <span class="modality-label">{{ modalityLabels[modality.type] | translate }}:</span>
            <div
              class="modality-chip"
              [class.not-configured]="!modality.entry"
              [class.limit-reached]="modality.entry?.limit && modality.entry.used >= modality.entry.limit"
            >
              <i [nimbusIcon]="modalityIcons[modality.type]"></i>
              <span>{{ modality.entry?.used ?? 0 }}/{{ modality.entry?.limit ?? 0 }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>
}
